import { breakpoint } from '@/helpers/BreakpointHelper';
import { isBrowser } from '@/helpers/BrowserHelper';
import React, { FC, useCallback } from 'react';
import { createPortal } from 'react-dom';
import styled, { keyframes } from 'styled-components';
/* 
스크롤 없이 브라우저 height 가 max-height인 modal 입니다
스크롤은 컨테이너 내부에 생성해주세요
*/
export interface ModalProps {
  isOpen?: boolean;
  // 모달 바깥쪽 누를시 닫을수 있는지 여부
  dismissable?: boolean;
  // 닫힘요청시 콜백
  onRequestClose: () => void;
  maxWidth?: string;
}

const backdropFadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 0.5;
  }
`;

const backdropFadeOut = keyframes`
  from {
    opacity: 0.5;
  }
  to {
    opacity: 0;
  }
`;

const slideIn = keyframes`
  from {
    top: -20px; 
  }
  to {
    top: 0;
  }
`;

const slideOut = keyframes`
  from {
    top: 0;
  }
  to {
    top: -20px;
  }
`;

const ModalContainer = styled.div<{ isOpen: boolean }>`
  display: ${({ isOpen }) => (isOpen ? `block` : `none`)};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  overflow: hidden;
`;
const ModalBackdrop = styled.div<{ isOpen: boolean }>`
  position: fixed;
  background-color: #000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  animation: ${({ isOpen }) => (isOpen ? backdropFadeIn : backdropFadeOut)}
    0.15s linear;
`;
export const ModalDialog = styled.div<{ isOpen: boolean; maxWidth?: string }>`
  max-height: calc(100vh - 1.75 * 2rem);
  position: fixed;
  width: 100%;
  top: 0;
  left: calc(50% - ${({ maxWidth }) => maxWidth || `880px`} / 2);
  max-width: ${({ maxWidth }) => maxWidth || `880px`};
  margin: 1.75rem auto;
  background-color: #fff;
  z-index: 1;
  animation: ${({ isOpen }) => (isOpen ? slideIn : slideOut)} 0.15s linear;

  ${breakpoint(`tablet`)} {
    margin: 0 auto;
    height: 100%;
    left: 0;
  }
`;

const Modal: FC<ModalProps> = ({
  children,
  isOpen = true,
  dismissable = false,
  onRequestClose,
  maxWidth,
  ...props
}) => {
  const onBackdropClick = useCallback(() => {
    if (dismissable) {
      onRequestClose();
    }
  }, [dismissable, onRequestClose]);

  if (!isBrowser) {
    return null;
  }

  return createPortal(
    <ModalContainer isOpen={isOpen} {...props}>
      <ModalDialog isOpen={isOpen} maxWidth={maxWidth}>
        {children}
      </ModalDialog>
      <ModalBackdrop isOpen={isOpen} onClick={onBackdropClick} />
    </ModalContainer>,
    document.body,
  );
};

export default Modal;
